import { logger } from '@/lib/logger'

export class SafeStorage {
  private storage: Storage

  constructor(storage: Storage) {
    this.storage = storage
  }

  getItem<T>(key: string, initialValue: T): T {
    try {
      const item = this.storage.getItem(key)
      if (!item) {
        this.setItem(key, initialValue)
        return initialValue
      }
      return typeof initialValue === 'string' ? (item as T) : JSON.parse(item)
    } catch (error) {
      logger.error(`Error parsing storage key "${key}": ${error}`)
      this.setItem(key, initialValue)
      return initialValue
    }
  }

  setItem<T>(key: string, value: T): void {
    try {
      if (typeof value === 'string') {
        this.storage.setItem(key, value)
      } else {
        this.storage.setItem(key, JSON.stringify(value))
      }
    } catch (error) {
      logger.error(`Error setting storage key "${key} ": ${error}`)
    }
  }

  removeItem(key: string): void {
    try {
      this.storage.removeItem(key)
    } catch (error) {
      logger.error(`Error removing storage key "${key}": ${error}`)
    }
  }
}
